import { useParams } from "react-router-dom";
import EnhancementAccountDetail from "./EnhancementAccountDetail";
import { useEffect } from "react";

import { analytics, triggerLogEvent } from "../../../../config/firebase";

const AccountDetail = () => {
  const params = useParams();
  useEffect(() => {
    triggerLogEvent(analytics, "acc_detail", {});
  }, []);

  return <EnhancementAccountDetail customerId={params?.id} />;
};
export default AccountDetail;
